// extracted by mini-css-extract-plugin
export default {"layout":"ForgotPassword_layout__1yttL","card":"ForgotPassword_card__WivJD","content":"ForgotPassword_content__7RULz","content__title":"ForgotPassword_content__title__ljp06"};